import styled, { css } from "styled-components";

/**
 * Mini helper-component to easily divide flexbox layouts between left and right sides.
 * @example
 * ```jsx
 * <MyFlexboxRow>
 *  <LeftElement1 />
 *  <LeftElement2 />
 *  <Spacer />
 *  <RightElement1 />
 * </MyFlexboxRow>
 * ```
 *
 * If you use a flexbox with a gap, you can add the following CSS to fix the double-gap around the spacer:
 *
 * ```css
 * .my-flexbox-row {
 *   display: flex;
 *   gap: 4px;
 *   ${Spacer} {
 *     margin-inline: -4px auto;
 *   }
 * }
 * ```
 */
export const Spacer = styled.div<{ $vertical?: boolean }>`
  ${({ $vertical }) =>
    $vertical
      ? css`
          margin-top: auto;
          margin-bottom: auto;
        `
      : css`
          margin-left: auto;
          margin-right: auto;
        `}
`;
